import "../vendors/what-input.min";
import "babel-polyfill";
import "../vendors/objectFitPolyfill.basic.min";
import lozad from "lozad/dist/lozad.js";
// import './modules/validation/mask';
import { isInViewport } from "./modules/helpers/viewport";

import { COOKIE_GDPRC } from "./shared/global/variables";

import "./plugins/vueFilters";
import requestHelper from "./plugins/requestHelper";
import { findClosestElementByClass } from "./modules/helpers/dom/closest";

import { setHeight } from "./plugins/setHeight";
import globals from "./plugins/globals";
import tests from "./plugins/testing";
import { getMediaQ } from "./plugins/mediaQ";
import errors from "./plugins/errors";
import cookies from "./plugins/cookies";
import { popupTY } from "./modules/popup/popup-thankyou";
import { paralax } from "./plugins/paralax";
import alignItems from "./plugins/alignItems";
import biggerIcons from "./plugins/biggerIcons";

import { eDropdown } from "./modules/dropdown/dropdown";
import { dropdownAnimation } from "./modules/dropdown/dropdownAnimation";
import { formInputs } from "./modules/forms/inputs";
import { attachments } from "./modules/forms/attachment";
import { toggleBox } from "./modules/toggleBox/toggleBox";
import { approvals } from "./modules/approvals/approvals";
import { shList } from "./modules/drop-list/shList";
import { animatedCircle } from "./modules/animatedCircle/animatedCircle";
import { mainNav } from "./modules/menu/main-nav";
import { POS } from "./modules/pos/pos";
import { floatingMenu } from "./modules/menu/floatingMenu";
import overflow from "./modules/lp/overflow";
import logoMobile from "./modules/lp/logoMobile";
import popupCookies from "./modules/popup-cookies/popup-cookies";
// import {
// 	focusMenu
// } from './modules/menu/focusMenu';
import { surveys } from "./modules/survey/survey";
import { dAction } from "./modules/dataAction/dataAction";
import { exitPopup } from "./modules/exitPopup/exitPopup";
import { exitIntentPopup } from "./modules/exitIntentPopup/exitIntentPopup";
import { betaPopup } from "./modules/betaPopup/betaPopup";
import { videos } from "./modules/video/videos";
import { tabs } from "./modules/tabs/tabs";
import { sForm } from "./modules/ajaxForm/ajax";
import { wcag } from "./plugins/wcag";
import { bindTooltip } from "../vendors/tooltips";
import topSlide from "./modules/top_slider/topSlider";
import { showBulletInfo } from "./modules/showBulletInfo/showBulletInfo";
import setCurrClientCookie from "./modules/currClient/currClient";
import PacketsTv from "./modules/packetsTv";
import accordion from "./modules/lp/accordion";
import scrollToElem from "./modules/lp/scrollToElem";
import LPLegalShow from "./modules/lp/legal";
import phoneInput from "./modules/lp/phoneInput";
import detectCarousel from "./modules/lp/detectCarousel";
import changeAriaLabel from "./modules/lp/changeAriaLabel";
import changeBackgroundHeight from "./modules/lp/changeBackgroundHeight";
import detectThankYou from "./modules/lp/detectThankYou";
import cardCreator from "./modules/cardCreator/cardCreator";
import statementBox from "./modules/statementBox/statementBox";
import currentYear from "./modules/currentYear/currentYear";

import "./modules/search-help/helpSearch";
import "./modules/search-help/helpSearch-b2b";
import "./modules/diagnostics/diagnostics";
import "./modules/help/help";
import "./modules/offer-table/offer-table";
import "./modules/offerCard/offer-card";
import "./modules/offerCard/offer-filters";
import "./modules/offerCard/offer-cards";

// import {removeDots} from './removeDots';
// import {sliders} from './sliders';
// import {initGauges} from './modules/gauge/gauges';
import { priceWrapper } from "./modules/offer-table/priceWrapper";
// import {circleNumber} from './modules/circlesNumber/circlesNumber';
// import {iconsHeight} from './iconsHeight';
import { attachment } from "./modules/forms/attachment";
import { numberOfferTableCells } from "./modules/offer-table/numberOfferTableCells";
import { wrapOfferTableCellsInRows } from "./modules/offer-table/wrapOfferTableCellsInRows";
import { removeDuplicateTableCells } from "./modules/offer-table/removeDuplicateTableCells";
import { setTableCellsHeight } from "./modules/offer-table/setTableCellsHeight";
import { tabOffer } from "./modules/offer-table/tab-offer";
// import {toggleOfferTableDropdownList} from './modules/offer-table/toggleOfferTableDropdownList';
// import {toggleOfferTableMobileItems} from './modules/offer-table/toggleOfferTableMobileItems';
import { setOfferTableButtonsAsSticky } from "./modules/offer-table/setOfferTableButtonsAsSticky";
// import {bannerVideo} from './modules/banner-videos/bannerVideo';
import { productChoice } from "./modules/productChoice/productChoice";
import { elements } from "./modules/helpers/dom/elementsManagement";
// import {popup} from "./modules/popup/popup";
import { copyOfferTable } from "./modules/offer-table/copyOfferTable";
// import './polyfills';
import { toOffer } from "./modules/offer-table/to-offer";
import { prepareAllPossibleSearchEngines } from "./modules/searchChannels";
// import {filterCategories} from './modules/filterCategories';
import { infoTab } from "./modules/tabs/infoTab";
import { tabManipulate } from "./modules/tabs/tab-manipulate";

import TabsFilters from "./modules/filterCategories";
// import {toggleOfferTableComparisonPopup} from './modules/offer-table/toggleOfferTableComparisonPopup';
import { bonusScrollTo } from "./modules/offer-table/bonusScrollTo";
// import {benefitTabs} from "./modules/benefitTabs/benefitTabs";
// import {topper} from "./modules/topper/topper";
// import {checkAvailability} from "./modules/checkAvailability/checkAvailability";
// import {ie} from "./modules/helpers/dom/ie";
import { cookiesBanner } from "./modules/cookiesBanner/cookiesBanner";
// import {helpSearch} from "./modules/search-help/helpSearch";
import { photoCarousel } from "./modules/photo-carousel/photo-carousel";
import { topBannerSlider } from "./modules/topBannerSlider/topBannerSlider";
import { ecommerceApprovals } from "./modules/approvals/ecommerce-approvals.js";

// import {eTooltip} from "./modules/ecommerce/tooltip";
// import {datepicker} from "./modules/ecommerce/datepicker";

import { pricingSimulator } from "./modules/pricingSimulator/pricingSimulator";
import { checkOfferTableColumnsAmount } from "./modules/offer-table/checkOfferTableColumnsAmount";
import { line } from "./modules/offer-table/lineMerge";
// import {ecommercePopup} from "./modules/popup/ecommerce-popup";
// import {newsletter} from "./modules/newsletter/newsletter-popup";
import { bannersCompare } from "./modules/banners/banners-compare";

import { LoopFocus } from "./modules/loopfocus/loopfocus";

import { searchElements } from "./modules/searchElements/searchElements";
import { teaserSlider } from "./modules/b2b/teaserSlider";
import { getParameterByName } from "./modules/helpers/getParameter";
import { getOffsetTop } from "./plugins/scrollTo";
import { EbookForm } from "./modules/ebookForm/index";

import showYouTube from "./modules/showYouTube/showYouTube";
import contactWidget from "./modules/contactWidget/contactWidget";

import {illegalContent} from './modules/forms/illegalContent';

let canInitMap = false;
let appLoaded = false;
let counter = 0;

const templateDiv = document.querySelectorAll("[data-template]");
if (templateDiv.length < 1) {
	loadApp();
} else {
	for (let i = 0; i < templateDiv.length; i++) {
		requestHelper
			.request("get", templateDiv[i].getAttribute("data-template"))
			.then((res) => {
				templateDiv[i].innerHTML = res;
				counter++;
				if (counter === templateDiv.length) {
					loadApp();
				}
			})
			.catch((e) => console.log(e));
	}
}



function loadApp() {
	var vueApp = document.querySelector("#app");
	var designMode = document.querySelector(
		".DesignMode, .EditMode, .CMSDeskContent"
	);

	if (designMode) {
		initJS(vueApp);
	} else if (vueApp) {
		window.vueApplication = new Vue({
			el: "#app",
			delimiters: ["{[{", "}]}"],
			data: {
				sdu_text: "Sprawdź dostępność",
				sdu_cityInput: "",
				sdu_streetInput: "",
				sdu_houseInput: "",
				sdu_apartmentInput: "",
				sdu_zipInput: "",
				sdu_postcode: "",
				sdu_cities: [],
				sdu_streets: [],
				sdu_show_cities: false,
				sdu_show_streets: false,
				sdu_disable_cities: false,
				sdu_disable_streets: false,
				sdu_timeout: "",
				sdu_form_state: 99,
				sdu_response: {},
				sdu_submitUrl: "",
				sdu_confirmUrl: "",
				sdu_removeUrl: "",
				sdu_method: "",
				sdu_cookie_exp: 0,
				sdu_showError: false,
				sdu_removingError: false,
				sdu_csrf_token: "",
				sdu_autocomplete_showed: false,
				showLoader: false,
				event: "",
				sduSet: false,
				sduChange: false,
				sduFormViewed: false,
				sduFormFillStart: false,
				recaptchaId: "",
				help_active_tile: "",
				MODULES: {
					filterCategories: "test",
				},
				scrolled: 0,
			},
			mounted: function () {
				const that = this;
				initJS(this.$el);
				appLoaded = true;
				if (canInitMap && appLoaded) {
					initMapNow();
				}
				const sduForm = document.querySelector("[data-sdu-form]");
				const sduMainForm = document.querySelector("[data-sdu-mainform]");
				if (sduForm) {
					this.sdu_submitUrl = sduForm.getAttribute("data-submit-url");
					this.sdu_confirmUrl = sduForm.getAttribute("data-confirm-url");
					this.sdu_removeUrl = sduForm.getAttribute("data-remove-url");
					this.sdu_method = sduForm.getAttribute("data-method");
					this.sdu_cookie_exp = Number(sduForm.getAttribute("data-cookie-exp"));
					this.event = sduForm.getAttribute("data-event");
				}
				if (cookies.getCookie("sdu_localization") !== "") {
					const sduCookie = JSON.parse(
						decodeURIComponent(cookies.getCookie("sdu_localization"))
					);
					that.sdu_cityInput = sduCookie.city;
					that.sdu_streetInput = sduCookie.street;
					that.sdu_houseInput = sduCookie.house;
					that.sdu_apartmentInput = sduCookie.flat;
					that.sdu_text = sduCookie.display_name;
					this.sduSet = true;
				}
				// if (sessionStorage.getItem("sdu_localization") !== null) {
				// 	const sdu = JSON.parse(
				// 		decodeURIComponent(sessionStorage.getItem("sdu_localization"))
				// 	);
				// 	that.sdu_cityInput = sdu.city;
				// 	that.sdu_streetInput = sdu.street;
				// 	that.sdu_houseInput = sdu.house;
				// 	that.sdu_apartmentInput = sdu.flat;
				// 	that.sdu_text = sdu.display_name;
				// 	this.sduSet = true;
				// }
				$("[data-popup-wrapper], body").click(function (event) {
					if (that.$refs.cityInput) {
						if (event.target.id !== that.$refs.cityInput.id) {
							that.sdu_show_cities = false;
						}
					}
					if (that.$refs.streetInput) {
						if (event.target.id !== that.$refs.streetInput.id) {
							that.sdu_show_streets = false;
						}
					}
				});
				// google analytics events for leadforms
				const availabilityPopupTriggers = document.querySelectorAll(
					'[data-action="popup_availability"]'
				);
				availabilityPopupTriggers.forEach((trigger) => {
					trigger.addEventListener("click", () => {
						that.gaEvent("skantarek", "view");
					});
				});

				const leadForms = document.querySelectorAll("[data-ga-param]");

				leadForms.forEach((form) => {
					const leadFormParam = form.getAttribute("data-ga-param");
					const inputs = form.querySelectorAll(
						"input[type=tel], input[type=email], input[type=text]"
					);

					var leadFormViewed = false;
					var leadFormFilled = false;

					const gaLeadFormView = function (form, eventType, param) {
						if (isInViewport(form)) {
							if (!leadFormViewed) {
								that.gaEvent(eventType, "view", param);
								leadFormViewed = true;
							}
						}
					};

					gaLeadFormView(form, "leadform", leadFormParam);
					document.addEventListener("scroll", () => {
						gaLeadFormView(form, "leadform", leadFormParam);
					});

					const gaLeadFilling = function () {
						if (!leadFormFilled) {
							that.gaEvent("leadform", "start", leadFormParam);
							leadFormFilled = true;
						}
					};
					inputs.forEach((input) => {
						input.addEventListener("input", () => {
							if (input.value !== "") {
								gaLeadFilling();
							}
						});
					});
				});

				// google analytics events for sdu forms
				const gaSduMainFormView = function () {
					if (isInViewport(sduMainForm) && !that.sduSet) {
						if (!that.sduFormViewed) {
							that.gaEvent("skantarek", "view");
							that.sduFormViewed = true;
						}
					}
				};
				const gaSduFormFilling = function (form) {
					const inputs = form.querySelectorAll(
						"input[type=tel], input[type=email], input[type=text]"
					);
					const gaLeadFilling = function () {
						if (!that.sduFormFillStart) {
							that.gaEvent("skantarek", "start");
							that.sduFormFillStart = true;
						}
					};
					inputs.forEach((input) => {
						input.addEventListener("input", () => {
							if (input.value !== "") {
								gaLeadFilling();
							}
						});
					});
				};
				if (sduMainForm) gaSduMainFormView();
				if (sduMainForm) document.addEventListener("scroll", gaSduMainFormView);

				if (sduForm) gaSduFormFilling(sduForm);
				if (sduMainForm) gaSduFormFilling(sduMainForm);

				// google analytics events for bmt popup
				const bmtPopup = document.querySelector(
					'[data-popup="redirecting"][data-ga-popup-param]'
				);
				if (bmtPopup) {
					that.gaEvent("skantarek", "BMT", "view");
					const btnClose = bmtPopup.querySelector(
						"[data-popup-close].popup-b2c__close-btn"
					);
					const btns = bmtPopup.querySelectorAll("[data-ga-popup-param-btn]");

					bmtPopup.addEventListener("click", (e) => {
						if (e.target == btnClose) that.gaEvent("skantarek", "BMT", "close");
						btns.forEach((btn) => {
							const param = btn.getAttribute("data-ga-popup-param-btn");
							if (e.target == btn) that.gaEvent("skantarek", "BMT", `click ${param}`);
						});
					});
				}
			},
			updated: function () {
				dAction.init();
				// filterCategories.checkCategory(this.$el);

				// eDropdown.init(this.$el);
				// dropdownAnimation.offerDropdown(this.$el);

				bindTooltip(this.$el);
				dAction.init(this.$el);
				const that = this;
				setTimeout(() => {
					that.scrollToButton();
				}, 1000);
			},
			methods: {
				// offerChangeTab: function (event) {
				// 	const parent = findClosestElementByClass(event.target, 'tab-offer__container');
				// 	let nodes;
				// 	const parent2 = findClosestElementByClass(event.target, 'swiper-wrapper');
				// 	let nodes2;
				// 	if (parent) {
				// 		nodes = Array.prototype.slice.call( parent.children );
				// 	}
				// 	if (parent2) {
				// 		nodes2 = Array.prototype.slice.call( parent2.children );
				// 	}

				// 	let element;
				// 	if (event.target.classList.contains('switcher-tab__tab') && nodes2.length) {
				// 		element = event.target;
				// 		this.tab_id2 = nodes2.indexOf(element);
				// 	}
				// 	else {
				// 		if (event.target.classList.contains('tab-offer')) {
				// 			element = event.target;
				// 		}
				// 		else {
				// 			element = findClosestElementByClass(event.target, 'tab-offer');
				// 		}
				// 		this.tab_id = nodes.indexOf(element);
				// 		// this.tab_id2 = 0;
				// 		tabs.refreshTabs();
				// 	}
				// 	history.pushState(null, null, '?tab1=' + this.tab_id + '&tab2=' + this.tab_id2);

				// },
				scrollToButton: function () {
					const buttons = document.querySelectorAll(
						"#" + getParameterByName("toPosition")
					);
					const tabContainer = document.querySelector(
						".tab-offer__container[data-scroll]"
					);
					const tab = tabContainer ? tabContainer.querySelector(".tab-offer") : null;

					if (buttons && this.scrolled === 0) {
						buttons.forEach((button) => {
							if (getOffsetTop(button) > 0) {
								this.scrolled = 1;
								$("html, body").animate(
									{
										scrollTop: getOffsetTop(button) - window.innerHeight + 55,
									},
									300
								);
							}
						});
					}
					if (tab && this.scrolled === 0) {
						this.scrolled = 1;
						$("html, body").animate(
							{
								scrollTop: getOffsetTop(tab) - 80,
							},
							300
						);
					}
				},
				sduShowAutocomplete: function (type, event) {
					const that = this;
					let url;
					let element;
					this.sduRemoveError(event);

					if (!that.sdu_autocomplete_showed) {
						document.addEventListener("keydown", function (event) {
							that.sdu_autocomplete_showed = true;
							if (event.keyCode === 40) {
								event.preventDefault();
								if (event.target.tagName === "INPUT") {
									element = event.target.parentNode;
									if (element) {
										element = element.querySelector(".popup-b2c__autocomplete li a");
									}
								} else {
									element = event.target.parentNode;
									if (element.nextElementSibling) {
										element = element.nextElementSibling.querySelector("a");
									} else if (element.parentNode.firstElementChild) {
										element = element.parentNode.firstElementChild.querySelector("a");
									}
								}
								if (element) {
									element.focus();
								}
							} else if (event.keyCode === 38) {
								event.preventDefault();
								element = event.target.parentNode;
								if (element) {
									if (element.previousElementSibling) {
										element = element.previousElementSibling.querySelector("a");
									} else if (element.parentNode.lastElementChild) {
										element = element.parentNode.lastElementChild.querySelector("a");
									}
								}
								if (element) {
									element.focus();
								}
							}
						});
					}

					if (type === "city") {
						url = this.$refs.cityInput.getAttribute("data-url");
						this.sdu_streetInput = "";
						this.$refs.streetInput.parentNode.classList.remove("filled");
					}
					if (type === "street") {
						url = this.$refs.streetInput.getAttribute("data-url");
					}
					this.sdu_houseInput = "";
					this.sdu_apartmentInput = "";
					this.sdu_zipInput = "";
					this.$refs.houseInput.parentNode.classList.remove("filled");
					this.$refs.apartmentInput.parentNode.classList.remove("filled");
					clearTimeout(this.sdu_timeout);
					if (
						(type === "city" && this.sdu_cityInput.length > 2) ||
						(type === "street" && this.sdu_streetInput.length > 2)
					) {
						this.sdu_timeout = setTimeout(function () {
							requestHelper
								.request(
									"GET",
									url +
										"?city=" +
										encodeURI(that.sdu_cityInput) +
										"&street=" +
										encodeURI(that.sdu_streetInput)
								)
								.then((res) => {
									if (type === "city") {
										that.sdu_cities = JSON.parse(res).values;
										if (!that.sdu_disable_cities) {
											that.sdu_show_cities = true;
										}
									}
									if (type === "street") {
										that.sdu_streets = JSON.parse(res).values;
										if (!that.sdu_disable_streets) {
											that.sdu_show_streets = true;
										}
									}
								})
								.catch((e) => console.log(e));
						}, 300);
					}
				},
				sduRemoveError: function (event) {
					if (event.target.value.length === 1) {
						const formGroup = findClosestElementByClass(event.target, "form-group");
						formGroup.classList.remove("has-error");
						formGroup.querySelector(".messages").innerHTML = "";
					}
				},
				sduFillCity: function (city, formId) {
					this.sdu_cityInput = city;
					this.sdu_show_cities = false;
					if (formId === "mainform") {
						this.$refs.cityInput_main.focus();
					} else {
						this.$refs.cityInput.focus();
					}
				},
				sduFillStreet: function (street, formId) {
					this.sdu_streetInput = street;
					this.sdu_show_streets = false;
					if (formId === "mainform") {
						this.$refs.streetInput_main.focus();
					} else {
						this.$refs.streetInput.focus();
					}
				},
				gaEvent: function (eventType, param1, param2) {
					dataLayer.push({
						event: eventType,
						eventParam1: param1,
						eventParam2: param2,
					});
				},
				sduClosePopup: function () {
					this.setCookies(this);
					// this.setSduSessionStorage(this);
					if (
						document
							.querySelector('[data-popup="availability"]')
							.classList.contains("is-active")
					) {
						document
							.querySelector('[data-popup="availability"] [data-popup-close]')
							.click();
					}
				},
				sduSubmit: function (formId) {
					const that = this;
					if (formId === "form") {
						that.recaptchaId = window.recaptcha_form;
						// that.sdu_csrf_token = that.$refs.sdu_popup_csrf_token.value;
					}
					if (formId === "mainform") {
						that.recaptchaId = window.recaptcha_mainform;
						// that.sdu_csrf_token = that.$refs.sdu_main_csrf_token.value;
					}
					that.sdu_csrf_token = that.$refs.sdu_popup_csrf_token.value;
					const productId = document.getElementById("sdu_product_id");
					let productIdValue = "";
					if (productId) {
						productIdValue = productId.value;
					}
					const positionInput = document.querySelector(
						"[data-sdu-form] [name=position]"
					);
					let positionInputValue = "";
					if (positionInput) {
						positionInputValue = positionInput.value;
					}
					const data = JSON.stringify({
						city: that.sdu_cityInput,
						street: that.sdu_streetInput,
						house: that.sdu_houseInput,
						flat: that.sdu_apartmentInput,
						postcode: that.sdu_zipInput,
						captcha: grecaptcha.getResponse(that.recaptchaId),
						product_id: productIdValue,
						position: positionInputValue,
						csrf_token: that.sdu_csrf_token,
					});
					// console.log("data", data);

					const formGroup = document.querySelector(
						"[data-sdu-" + formId + "] .form-popupb2c__re"
					);
					let canSend = false;
					if (
						grecaptcha.getResponse(that.recaptchaId) === "" &&
						that.sdu_form_state === 4
					) {
						formGroup.classList.add("has-error");
						canSend = false;
					} else {
						formGroup.classList.remove("has-error");
						canSend = true;
					}
					if (
						!sForm.handleFormSubmit(
							document.querySelector("[data-sdu-" + formId + "]"),
							true
						) &&
						canSend
					) {
						that.showLoader = true;
						requestHelper
							.request(that.sdu_method, that.sdu_submitUrl, data)
							.then((res) => {
								res = JSON.parse(res);
								if (res.success == true && res.code > -1) {
									that.sdu_postcode = res.postcode;
									if (res.code === 0) {
										that.sdu_text = res.display_name;

										this.setCookies(that);

										this.sduClosePopup();
										that.sduConfirm(formId);
									} else if (res.code === 5) {
										that.sdu_text = res.display_name;
										if (res.redirect) {
											this.setCookies(that);
											// this.setSduSessionStorage(that);
											// ga event for success
											that.gaEvent("skantarek", "success");
											window.location.href = res.redirect;
										} else {
											this.reloadLocation();
										}
									} else if (res.code === 6) {
										that.sdu_text = res.display_name;

										this.setCookies(that);
										// this.setSduSessionStorage(that);
										// ga event for success
										that.gaEvent("skantarek", "success");
										window.location.href = res.redirect;
									} else if (res.code === 7) {
										that.sdu_text = res.display_name;

										this.setCookies(that);
										// this.setSduSessionStorage(that);
										// ga event for success
										that.gaEvent("skantarek", "success");
										this.sduClosePopup();
										document
											.querySelector('[data-action="popup_' + res.action + '"]')
											.click();
										that.showLoader = false;
									} else {
										that.showLoader = false;
									}
									if (res.code !== 6) {
										that.sdu_form_state = res.code;
										that.sdu_response = res;
										that.sdu_showError = false;
									}
								} else {
									that.sdu_showError = true;
									that.showLoader = false;
									// ga event for fail
									that.gaEvent("skantarek", "fail");
								}
								grecaptcha.reset(that.recaptchaId);
							})
							.catch((e) => {
								console.log(e);
								that.sdu_showError = true;
								that.showLoader = false;
								grecaptcha.reset(that.recaptchaId);
								// ga event for fail
								that.gaEvent("skantarek", "fail");
							});
					}
				},
				setCookies: function (that) {
					cookies.setCookie(
						"sdu_localization",
						encodeURIComponent(
							`{"city": "${that.sdu_cityInput}", "street": "${that.sdu_streetInput}","house": "${that.sdu_houseInput}","flat": "${that.sdu_apartmentInput}","postcode": "${that.sdu_postcode}","display_name": "${that.sdu_text}"}`
						)
						// that.sdu_cookie_exp
					);
					that.sduSet = true;
				},
				setSduSessionStorage: function (that) {
					sessionStorage.setItem(
						"sdu_localization",
						encodeURIComponent(
							`{"city": "${that.sdu_cityInput}", "street": "${that.sdu_streetInput}","house": "${that.sdu_houseInput}","flat": "${that.sdu_apartmentInput}","postcode": "${that.sdu_postcode}","display_name": "${that.sdu_text}"}`
						)
					);
					that.sduSet = true;
				},
				removeSduSessionStorage: function (that) {
					sessionStorage.removeItem("sdu_localization");
					// that.sduSet = false;
				},
				removeSduCookie: function (that) {
					cookies.setCookie("sdu_localization", "", "");
					// that.sduSet = false;
				},
				reloadLocation: function () {
					this.setCookies(this);
					// this.setSduSessionStorage(this);
					location.reload();
				},
				sduFormClear: function (dataForm) {
					const form = document.querySelector(`[${dataForm}]`);
					const inputs = form.querySelectorAll("input[type='text']");
					inputs.forEach((input) => {
						const parent = input.parentNode;
						input.value = "";
						parent.classList.remove("filled");
					});
				},
				sduConfirm: function () {
					const that = this;
					const productId = document.getElementById("sdu_product_id");
					let productIdValue = "";
					if (productId) {
						productIdValue = productId.value;
					}
					const positionInput = document.querySelector(
						"[data-sdu-form] [name=position]"
					);
					let positionInputValue = "";
					if (positionInput) {
						positionInputValue = positionInput.value;
					}
					const data = JSON.stringify({
						city: that.sdu_cityInput,
						street: that.sdu_streetInput,
						house: that.sdu_houseInput,
						flat: that.sdu_apartmentInput,
						postcode: that.sdu_zipInput,
						captcha: grecaptcha.getResponse(that.recaptchaId),
						product_id: productIdValue,
						position: positionInputValue,
						csrf_token: that.sdu_csrf_token,
					});
					// console.log("data confirm", data);
					that.showLoader = true;
					requestHelper
						.request(that.sdu_method, that.sdu_confirmUrl, data)
						.then((res) => {
							res = JSON.parse(res);
							if (res.success == true) {
								/*
                                if (document.querySelectorAll('[data-reload-page]').length) {
                                	location.reload();
                                }
                                */
								this.sduClosePopup();
								that.sdu_postcode = res.postcode;
								that.sdu_text = res.display_name;
								this.setCookies(that);
								// this.setSduSessionStorage(that);
								that.sdu_form_state = 99;
								that.sdu_showError = false;

								this.sduShowHideReferencedElements(res.display_conditions);

								// ga event for success
								that.gaEvent("skantarek", "success");
								// gtm event for specified tech service from api
								if (that.event) {
									if (cookies.getCookie(COOKIE_GDPRC) == "1") {
										requestHelper
											.request("get", that.event)
											.then((response) => {
												response = JSON.parse(response);
												var specifiedService = res.display_conditions.filter((obj) => {
													return (
														obj.service.toLowerCase() === response.service.toLowerCase()
													);
												});
												const excludedTechnologies = response.excludedTechnologies.map(
													(tech) => tech.toLowerCase()
												);
												const currentTechnology =
													specifiedService[0].technology.toLowerCase();
												if (
													currentTechnology &&
													!excludedTechnologies.includes(currentTechnology)
												) {
													const script = document.createElement("script");
													if (response.text) {
														script.text = response.text;
													} else {
														script.src = response.src;
													}
													const el = document.getElementsByTagName("script")[0];
													el.parentNode.insertBefore(script, el);
												}
											})
											.catch((e) => console.log(e));
									}
								}

								if (that.sdu_response.redirect) {
									//force page reload after sdu check
									window.location.href = that.sdu_response.redirect;
								} else if (res.redirect) {
									window.location.href = res.redirect;
								} else {
									location.reload();
								}
							} else {
								that.sdu_showError = true;
								// ga event for fail
								that.gaEvent("skantarek", "fail");
							}
							that.showLoader = false;
						})
						.catch((e) => {
							console.log(e);
							that.sdu_showError = true;
							that.showLoader = false;
							// ga event for fail
							that.gaEvent("skantarek", "fail");
						});
				},
				sduRemove: function () {
					const that = this;
					that.showLoader = true;
					requestHelper
						.request(that.sdu_method, that.sdu_removeUrl)
						.then((res) => {
							res = JSON.parse(res);
							if (res.success == true) {
								this.removeSduCookie(that);
								that.sdu_removingError = false;
								if (that.sdu_response.redirect) {
									//force page reload after sdu check
									window.location.href = that.sdu_response.redirect;
								} else if (res.redirect) {
									window.location.href = res.redirect;
								} else {
									location.reload();
								}
							} else {
								that.sdu_removingError = true;
							}
							that.showLoader = false;
						})
						.catch((e) => {
							console.log(e);
							that.sdu_removingError = true;
							that.showLoader = false;
						});
				},
				sduShowHideReferencedElements: function sduShowHideReferencedElements(
					display_conditions
				) {
					//debugger;
					try {
						var sdu_referenced_elements = document.querySelectorAll(
							"[data-sdu-condition]"
						);

						if (sdu_referenced_elements.length && display_conditions) {
							for (var i = 0; i < sdu_referenced_elements.length; i++) {
								var element = sdu_referenced_elements[i];
								var show = false;

								if (element.dataset.sduCondition == "checked") {
									if (
										element.dataset.sduConditionService &&
										element.dataset.sduConditionTechnology
									) {
										//jeśli zdefiniowana service
										var service = element.dataset.sduConditionService.toLowerCase();
										var tech = element.dataset.sduConditionTechnology.toLowerCase();

										for (var j = 0; j < display_conditions.length; j++) {
											if (
												display_conditions[j].service == service &&
												display_conditions[j].technology == tech
											) {
												show = true;
											}
										}
									} else {
										show = true;
									}
								}

								element.style.display = show ? "block" : "none";
							}
						}
					} catch (e) {
						console.error(e);
					}
				},
				sduChoose: function (obj) {
					const that = this;
					that.sdu_cityInput = obj.city;
					obj.street === null
						? (that.sdu_streetInput = "")
						: (that.sdu_streetInput = obj.street);
					that.sdu_houseInput = obj.house;
					obj.flat === null
						? (that.sdu_apartmentInput = "")
						: (that.sdu_apartmentInput = obj.flat);
					that.sdu_zipInput = obj.postcode;
					that.sduConfirm();
				},
			},
		});
	}
	if (typeof grecaptcha !== "undefined" || grecaptcha !== null) {
		grecaptcha.ready(function () {
			const form_recaptcha = document.getElementById("form_recaptcha");
			const mainform_recaptcha = document.getElementById("mainform_recaptcha");
			const comment_recaptcha = document.getElementById("commentRecaptcha");
			const withdrawalform_recaptcha = document.getElementById(
				"withdrawalform_recaptcha"
			);
			const leadform_recaptcha = document.querySelectorAll("#leadform_recaptcha");
			if (form_recaptcha) {
				window.recaptcha_form = grecaptcha.render(form_recaptcha, {
					sitekey: form_recaptcha.getAttribute("data-sitekey"),
				});
			}
			if (mainform_recaptcha) {
				window.recaptcha_mainform = grecaptcha.render(mainform_recaptcha, {
					sitekey: mainform_recaptcha.getAttribute("data-sitekey"),
				});
			}
			if (withdrawalform_recaptcha) {
				window.recaptcha_withdrawalform = grecaptcha.render(
					withdrawalform_recaptcha,
					{
						sitekey: withdrawalform_recaptcha.getAttribute("data-sitekey"),
						callback: function () {
							const recaptchaWithdrawalError = form.querySelector(
								"#withdrawalform_recaptchaError"
							);
							if (recaptchaWithdrawalError.classList.contains("is-shown")) {
								recaptchaWithdrawalError.classList.remove("is-shown");
							}
						},
					}
				);
			}
			if (leadform_recaptcha) {
				leadform_recaptcha.forEach((recaptcha) => {
					window["leadform_recaptcha_" + recaptcha.getAttribute("data-form-id")] =
						grecaptcha.render(recaptcha, {
							sitekey: recaptcha.getAttribute("data-sitekey"),
							callback: function () {
								const recaptchaLeadformError = form.querySelector(
									"#leadform_recaptchaError"
								);
								if (recaptchaLeadformError.classList.contains("is-shown")) {
									recaptchaLeadformError.classList.remove("is-shown");
								}
							},
						});
				});
			}
			if (comment_recaptcha) {
				grecaptcha.render(comment_recaptcha, {
					sitekey: comment_recaptcha.getAttribute("data-sitekey"),
					callback: correctCommentRecaptcha,
				});
			}
		});
	} else {
		console.log("grecaptcha not defined");
	}
}

window.initMap = () => {
	canInitMap = true;
	if (canInitMap && appLoaded) {
		initMapNow();
	}
};

function initMapNow() {
	const PosNode = document.querySelector(".pos");
	if (PosNode) {
		const PosCl = new POS(PosNode);
	}
}

function pageLoad() {
	//   //validateNewsletter();
	popupCookies();
	showAcceptance();
	overflow();
	logoMobile();
	detectCarousel();
	// enableSubscribeButton();
	setTimeout(changeAriaLabel, 1000);
	accordion();
	phoneInput();
	scrollToElem();
	changeBackgroundHeight();
	detectFilledFields();
	showFormAcceptance();
	tagRequiredFields();
	prepareFormFields();
	prepareAcceptPanel();
	startAjaxLoader();
	//   //enableSubmitButton();
	ajaxTabs();
	centerNewsletterPanel();
	closeNewsletter();
	detectThankYou();
	cardCreator();
	showYouTube();
	statementBox();
	contactWidget();
	currentYear();


	const observer = lozad(".lozad", {
		// load: function(el) {

		// Custom implementation to load an element
		// e.g. el.src = el.getAttribute('data-src');
		// },
		loaded: function (el) {
			if (el.hasAttribute("data-object-fit") && el.tagName == "PICTURE") {
				objectFitPolyfill(el.querySelector("img"));
			}
			// let par = el.parentNode;
			// if (par.classList.contains('banner-main__bg')){
			// 	par.classList.add('loaded');
			// }
		},
	});
	observer.observe();
	formInputs.init(document.querySelectorAll("input, textarea"));
	toggleBox.toggle({
		targetClassName: "contactAcceptances",
		parentClassName: "contact-box__approvals",
		contentClassName: "contactApprovalsContent",
		state: "showHide",
	});
	approvals.acceptAll(
		"totalCheck",
		"contact-box__approvals",
		"contactApprovalsContent"
	);
	bindTooltip(document.querySelector(".form__accept-content"));
}

var observer;
var timeoutLozad;

function initJS($parentAppSelector) {
	if (!NodeList.prototype.forEach && Array.prototype.forEach) {
		NodeList.prototype.forEach = Array.prototype.forEach;
	}

	window.addEventListener("keydown", (e) => {
		if (
			e.keyCode === 13 &&
			e.target.tagName != "BUTTON" &&
			e.target.tagName != "TEXTAREA" &&
			e.target.tagName != "A" &&
			!e.target.hasAttribute("data-tab") &&
			!e.target.hasAttribute("data-taboffer") &&
			!e.target.hasAttribute("data-actiontab")
		)
			e.preventDefault();
	});

	errors.init();
	globals.testsMode = tests.paramMode();
	globals.mediaQ = getMediaQ();

	paralax.init();
	alignItems();
	biggerIcons();
	shList();
	bindTooltip($parentAppSelector);

	wcag.checkContrast();
	wcag.skiplinks();

	floatingMenu.init();
	// focusMenu.init();
	wcag.skiplinks();

	eDropdown.init($parentAppSelector); // TODO: check it
	dropdownAnimation.offerDropdown($parentAppSelector); // TODO: check it
	tabOffer.init();

	surveys.init();

	const $doc = $($parentAppSelector);
	$doc.find("#zipcode").mask("00-000");
	$doc.find("[type=tel]").mask("000000000");

	formInputs.init(document.querySelectorAll("input, textarea"));
	attachments.init();
	toggleBox.toggle({
		targetClassName: "contactAcceptances",
		parentClassName: "contact-box__approvals",
		contentClassName: "contactApprovalsContent",
		state: "showHide",
	});
	approvals.acceptAll(
		"totalCheck",
		"contact-box__approvals",
		"contactApprovalsContent"
	);
	sForm.initSend();

	dAction.init($parentAppSelector);
	videos.init();
	tabs.init();
	tabs.refreshTabs();
	topSlide();

	animatedCircle.animate();
	mainNav.init();

	showBulletInfo.init();
	setCurrClientCookie();

	const $appPacketsTvWrap = $parentAppSelector.querySelector(
		"[data-search-channels]"
	);
	const AppPacketsTv = new PacketsTv({
		root: $appPacketsTvWrap,
	});
	const AppPacketsTvTabsFilters = new TabsFilters({
		$root: $appPacketsTvWrap,
		IncomingInstanceOfComponent: AppPacketsTv,
	});
	const $appPacketsTv = $parentAppSelector.querySelector(
		AppPacketsTv.idElementParent
	);
	if ($appPacketsTvWrap) {
		AppPacketsTvTabsFilters.init();
		elements.counter($appPacketsTv, "tvPackages", undefined, AppPacketsTv);
		prepareAllPossibleSearchEngines($appPacketsTvWrap, AppPacketsTv);
	}

	//------------------------ popup-pricing-simulator.html

	const $appSimPacketsTvWrap = $parentAppSelector.querySelector(
		".channels-popup--simulator"
	);
	const AppSimPacketsTv = new PacketsTv({
		root: $appSimPacketsTvWrap,
		idElementParent: "#searchChannelsContentSim",
		setAppearanceZebra: false,
		showButtonMore: false,
	});
	const AppSimPacketsTvTabsFilters = new TabsFilters({
		$root: $appSimPacketsTvWrap,
		IncomingInstanceOfComponent: AppSimPacketsTv,
	});

	// AppSimPacketsTv.shownAllElements = true;
	const $appSimPacketsTv = $parentAppSelector.querySelector(
		AppSimPacketsTv.idElementParent
	);
	if ($appSimPacketsTvWrap) {
		AppSimPacketsTvTabsFilters.init();
		elements.counter(
			$appSimPacketsTv,
			"tvPackages",
			"popup_simulator",
			AppSimPacketsTv
		);
		prepareAllPossibleSearchEngines($appSimPacketsTvWrap, AppSimPacketsTv);
	}

	//------------------------

	const AppPacketsListTv = new PacketsTv({
		root: $parentAppSelector,
		idElementParent: "#packagesList",
	});
	const $appPacketsListTv = $parentAppSelector.querySelector(
		AppPacketsListTv.idElementParent
	);
	elements.counter($appPacketsListTv, "tvPackages", undefined, AppPacketsListTv);
	AppPacketsListTv.init();

	const $appPacketsListTvPopupWrap = $parentAppSelector.querySelector(
		"[data-popup-channels]"
	);
	const AppPacketsListTvPopup = new PacketsTv({
		root: $appPacketsListTvPopupWrap,
		idElementParent: "#packagesListPopup",
		setAppearanceZebra: false,
	});
	const AppPacketsListTvPopupTabsFilters = new TabsFilters({
		$root: $appPacketsListTvPopupWrap,
		IncomingInstanceOfComponent: AppPacketsListTvPopup,
	});
	const $appPacketsTvPopup = $parentAppSelector.querySelector(
		AppPacketsListTvPopup.idElementParent
	);
	if ($appPacketsListTvPopupWrap) {
		AppPacketsListTvPopupTabsFilters.init();
		elements.counter(
			$appPacketsTvPopup,
			"tvPackages",
			"popup",
			AppPacketsListTvPopup
		);
		prepareAllPossibleSearchEngines(
			$appPacketsListTvPopupWrap,
			AppPacketsListTvPopup
		);
	}

	// setHeight.stepWrapper();
	// setHeight.stepHeader();
	// setHeight.packagesBox();
	// setHeight.packagesPrice();
	// setHeight.tabOffer();
	// setHeight.boxIcons();
	// setHeight.tabsItems();
	setHeight.changeHeightAll();
	// setHeight.bannerCompareText();
	// sliders.tabOfferSlider();
	// sliders.packagesTabs();

	// removeDots.stepContainer();
	// circleNumber.addNumbers();
	// iconsHeight.packages();

	// copyOfferTable();

	illegalContent();

	priceWrapper();
	// toggleOfferTableDropdownList();
	// toggleOfferTableMobileItems();

	// numberOfferTableCells();
	// wrapOfferTableCellsInRows();
	// removeDuplicateTableCells();

	// bannerVideo.bannerVideoBackground();
	// window.bannerVideo = bannerVideo;
	if (document.querySelector(".filterContainer")) {
		productChoice.activate();
		productChoice.initPackagesNumber();
		productChoice.showMorePackages();
		// productChoice.scrollToContact();
	}

	// initGauges();
	// toOffer.init();

	// elements.counter('tvPackages');

	// // popup.init();
	// filterCategories.checkCategory();
	infoTab.initTabs();
	infoTab.setActiveTabInitPositions();
	// bonusScrollTo.scrollOnClick();
	// benefitTabs.changeTab();
	// setHeight.setTvBoxes();
	// Object.create(topper).init('mainTopperTimeline');
	// ie.init();
	// checkAvailability.init();
	photoCarousel.init();
	topBannerSlider.init();
	cookiesBanner.banner();
	cookiesBanner.initListeners();
	// helpSearch.init();
	Object.create(ecommerceApprovals).init("ecommerce-approvals");
	// eTooltip.init();
	// datepicker.init();
	pricingSimulator.init();
	Object.create(line).findLineToMerge();
	Object.create(line).findLineToMerge("packagesRow");
	// elements.counter('tvPackagesInTable', 4);
	// prepareAllPossibleSearchEngines();
	setTableCellsHeight();
	mainNav.init();
	// setTableCellsHeight();

	// newsletter.init();

	// checkOfferTableColumnsAmount();
	// setTableCellsHeight();
	// ecommercePopup.init();
	bannersCompare.init();

	observer = lozad(".lozad", {
		// load: function(el) {

		// Custom implementation to load an element
		// e.g. el.src = el.getAttribute('data-src');
		// },
		loaded: function (el) {
			if (el.hasAttribute("data-object-fit") && el.tagName == "PICTURE") {
				objectFitPolyfill(el.querySelector("img"));
			}
			// let par = el.parentNode;
			// if (par.classList.contains('banner-main__bg')){
			// 	par.classList.add('loaded');
			// }
		},
	});

	observer.observe();
	const imgLoadOnStart = document.querySelectorAll("[data-lozad-start]");
	// ... trigger the load of a image before it appears on the viewport
	timeoutLozad = setTimeout(() => {
		if (document.body.classList.contains("testing")) {
			[].forEach.call(document.querySelectorAll(".lozad"), (img) =>
				observer.triggerLoad(img)
			);
		} else {
			[].forEach.call(imgLoadOnStart, (img) => observer.triggerLoad(img));
		}
	}, 1000);
	exitPopup.init($parentAppSelector);
	exitIntentPopup.init($parentAppSelector);
	betaPopup.init($parentAppSelector);
	pageLoad();
	pageLoadAdhd();
	window.pageLoad = function () {
		pageLoad();
	};
	runOnDocumentReady();
	if (document.getElementById("form")) {
		document.getElementById("form").setAttribute("autocomplete", "off");
	}

	//------ PopupThankYou
	popupTY.init();

	//------ Manipulations with tabs
	tabManipulate.init();

	//------ Loop Focus
	new LoopFocus({
		button: ".main-navigation__hamburger",
		container: {
			name: "First Level Menu",
			main: ".header .menu",
			elements: "ul > li > a, .header .menu ul > li > button",
		},
		anotherLevels: [
			{
				name: "Second Level Menu",
				container: ".menu__level2",
				elements:
					".menu__list2 > li > a, .menu__level2 .menu__list2 > li > span.more, .menu__level2 .menu__list2 .menu__list-roll > li > a",
				returnButton: ".back.backToSite",
			},
			{
				name: "Third Level Menu",
				container: ".menu__list3",
				elements: "li a",
				returnButton: ".back.backToLevel",
			},
		],
	});

	//------ Loop Focus
	searchElements(".action-tab__tab", 3)
		.then((result) => {
			const elements = result;
			initTabsInfinityFocus();
			elements.forEach((el) => {
				el.addEventListener("click", (ev) => {
					initTabsInfinityFocus();
				});
			});

			function initTabsInfinityFocus() {
				let tabs = [...document.querySelectorAll(".offer-comparison")];
				tabs.forEach((el) => {
					let button = el.querySelector(".link.offer-comparison__link"),
						main = el.querySelector(".comparison-table"),
						elements = [
							...el.querySelectorAll(".comparison-table-header-bar__button"),
						];
					new LoopFocus({
						button: button,
						trigger: elements[0],
						container: {
							name: "Table",
							main: main,
							elements: elements,
						},
					});
				});
			}
		})
		.catch((error) => {
			console.log(error);
		});
	teaserSlider.initSlider();
	//Ebook class
	let ebookForm = new EbookForm();
	LPLegalShow();
}

document.addEventListener("scroll", function () {
	setOfferTableButtonsAsSticky();
	floatingMenu.init();
	animatedCircle.animate();
	animateCircleNumbers();
	animateCirclePercentage();
});

let resizeTimer;
$(window).on("resize", () => {
	clearTimeout(resizeTimer);

	resizeTimer = setTimeout(() => {
		if (globals.mediaQ != getMediaQ()) {
			globals.mediaQ = getMediaQ();

			animatedCircle.resetCirclesAnimation();
			animatedCircle.animate();
		}

		$.fn.matchHeight._update();

		dAction.resizePopups();
		tabs.refreshTabs();

		// setHeight.stepWrapper();
		// setHeight.stepHeader();
		// setHeight.packagesBox();
		// setHeight.packagesPrice();
		// setHeight.tabOffer();
		// setHeight.setTvBoxes();
		// setHeight.boxIcons();
		// setHeight.tabsItems();

		// iconsHeight.packages();
		// paralax.benefitContainer();
		// removeDots.stepContainer();
		// sliders.tabOfferSlider();
		// sliders.packagesTabs();
		// bannerVideo.bannerVideoBackground();
		// animatedCircle.animate();
		infoTab.setActiveTabInitPositions();
		// popup.resetSizes();
		// ie.init();
		photoCarousel.init();
		// ecommerceApprovals.prepareSetLabelsPosition();
		// mainNav.init();
		// setHeight.bannerCompareText();

		numberOfferTableCells();
		// wrapOfferTableCellsInRows();
		removeDuplicateTableCells();
		setTableCellsHeight();
		checkOfferTableColumnsAmount();
		setTableCellsHeight();
		pricingSimulator.setHeightOfScrollArea();
	}, 250);
	changeBackgroundHeight();
});

$(document).scroll(function () {
	// setOfferTableButtonsAsSticky();
});
